import './aitest.css'
import React from 'react'
import { Delete } from "@mui/icons-material"
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext';
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import Checkbox from '@mui/material/Checkbox';
import {useState} from "react";

export const DisplayMyCreatedTests = ({ chat, clickHandler, deleteHandler, setTemplateName, checkExpiration }) => {
    
    const [openDialog, handleDisplay] = useState(false);
    const [openDialogActivate, handleDisplayActivate] = useState(false);
    const [openConfirmDialog, handleConfirmDisplay] = useState(false);
    const [dialogtext, setDialogText] = useState('');
    const [isChecked, setIsChecked] = useState(0);

    let {
        deleteTest,
        deleteCollegeTest,
        activateTest,
        getConnectedAccount,
        connectedAccount,
        createcollegetestmode, 
       
      } = React.useContext(AITestContext);

      let {
        changeLanguage,
    } = React.useContext(StatusContext);

     
    const alertYes = () => {
        closeDialogBox()
        if (createcollegetestmode)
          deleteCollegeTest(chat)
        else
          deleteTest(chat)
      }

      const alertCancel = () => {
        closeDialogBox()
      }

      const closeDialogBox = () => {
        handleDisplay(false);
     };
  
     
     const openDialogBox = () => {
        handleDisplay(true);
     };

     const closeConfirmDialogBox = () => {
      handleConfirmDisplay(false);
    };

   const openConfirmDialogBox = () => {
      handleConfirmDisplay(true);
    }

    const confirmYes = () => {
      closeConfirmDialogBox()
    
    }

    const alertYesActivate = () => {
    
      closeDialogBoxActivate()
      chat.activated === 0 ?  chat.activated = 1 : chat.activated = 0
      setIsChecked(chat.activated)
      activateTest(chat)
    }

    const alertCancelActivate = () => {
      closeDialogBoxActivate()
    }

    const openDialogBoxActivate = () => {
      handleDisplayActivate(true);
   };

   const closeDialogBoxActivate = () => {
      handleDisplayActivate(false);
  };

    const handleActivateTest = async () =>
      {
        let price = parseFloat(chat.price).toFixed(2)
        if (chat.activated === 0 && price > 0 && !connectedAccount.verified)
        {
          setDialogText(`'${chat.chatname}': ${changeLanguage('aitest', 'text26')} `)
          openConfirmDialogBox()
          return
        }
       
        if (chat.activated === 0)
        {
          if (price > 0)
            {
              //check if author's connected account is set

              let res = await getConnectedAccount(chat.creator_id)
              console.log("handleActivateTest:", res)

              if (res.status === 404)
              {
                  console.log("User not found")
                  setDialogText(`'${chat.chatname}': ${changeLanguage('aitest', 'text26')} `)
                  openConfirmDialogBox()
                  return
              }
              else
              {
                //check if connected account has been created
                if (res.verified === false)
                {
                  setDialogText(changeLanguage('aitest', 'text18'))
                  openConfirmDialogBox()
                  return
                }
                else
                  setDialogText(changeLanguage('aitest', 'paidtestwarning'))
              }
            }
            else
            {
              setDialogText(`'${chat.chatname}': ${changeLanguage('aitest', 'text18')} `)
            }
        }
        else{
          setDialogText( `'${chat.chatname}': ${changeLanguage('aitest', 'text19')} `)
        }
        openDialogBoxActivate()
      }
    

     const handleDelete = () => {
        setDialogText(`'${chat.chatname}'. ${changeLanguage('aitest', 'text17')}` )
        openDialogBox()
    }

    return (
      <div>
        <div className="aitestChooseListItem" key={chat.id}>
          <div>
            <Checkbox
              checked={isChecked || chat.activated === 1}
              onChange={handleActivateTest}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 18, color: 'maroon', border: 'none' },
              
            }} />
        </div>
       
            <li className="displayTestName" 
                onClick={() => { clickHandler(chat); setTemplateName(chat.chatname) }}>
                
                 {chat.chatname} 
                 <div className="aitestByAuthor">
                 {`${changeLanguage('aitest', 'testprice')}${chat.price}`}
                </div>  
            </li>
        
          <div style={{marginTop: '5px'}}>
            <Delete className="promptIcon" onClick={handleDelete} />
          </div>

            <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogtext}/>
            <AlertDialog alertYes={alertYesActivate} alertCancel={alertCancelActivate} openDialog = {openDialogActivate} closeDialog = {closeDialogBoxActivate} prompt={dialogtext}/>
            <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogtext}/>
        </div>
        </div>
    )
}